import { KeyboardArrowUp, Storefront } from "@mui/icons-material"
import { IconButton, Menu, MenuItem, Stack, Typography } from "@mui/material"
import useDataManager from "hooks/useDataManager";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setChangeBizLoading } from "store/sysSlice";

const BizSelect = ({ bizList, isMobile }) => {
    const dispatch = useDispatch()
    const { selectBiz } = useDataManager()
    const biz = useSelector((state) => state?.biz?.data);
    const [open, setOpen] = useState(null);

    const handleClickBizMenu = (event) => {
        setOpen(event.currentTarget);
    };

    const handleCloseBizMenu = () => {
        setOpen(null);
    };

    const onSelectedBiz = (bizId) => {
        dispatch(setChangeBizLoading(true));
        selectBiz(bizId)
    }


    if (bizList?.length === 0) {
        return (
            !isMobile
                ? <Typography sx={{ px: 2 }} fontWeight='bold' variant="h6">
                    {biz?.name}
                </Typography>
                : null
        )
    }

    return (
        <div>
            {!isMobile
                ? <Stack
                    direction={{ xs: 'row-reverse', md: 'row' }}
                    alignItems='center'
                    sx={{ cursor: "pointer" }}
                    spacing={{ xs: 0, md: 1 }}
                    onClick={handleClickBizMenu}
                >
                    <Typography fontWeight='bold' variant="h6">
                        {biz?.name}
                    </Typography>
                    <KeyboardArrowUp
                        sx={{
                            transform: open ? "rotate(180deg)" : "rotate(0deg)",
                            transition: "transform 0.3s ease",
                        }}
                    />
                </Stack>

                : <IconButton onClick={handleClickBizMenu}>
                    <Storefront color="secondary" />
                </IconButton>
            }

            <Menu
                MenuListProps={{ "aria-labelledby": "long-button" }}
                anchorEl={open}
                open={open ? true : false}
                onClose={handleCloseBizMenu}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
                {bizList?.map((biz, idx) => {
                    return (
                        <MenuItem
                            sx={{
                                backgroundColor: "transparent !important",
                                "&:hover": { backgroundColor: "transparent !important" },
                                "&.Mui-selected": {
                                    backgroundColor: "transparent !important",
                                    "&:hover": { backgroundColor: "transparent !important" },
                                },
                            }}
                            key={idx}
                            onClick={() => onSelectedBiz(biz.id)}
                        >
                            <Typography>
                                {biz?.name}
                            </Typography>
                        </MenuItem>
                    )
                })}

            </Menu>
        </div>
    )
}

export default BizSelect